export default __webpack_public_path__ + "static/media/actionQuit.63ece5e2.svg";